// Clay palette for procedural placeholders. Matte plasticine tones so the
// stand-in art already reads as the right product while sprites are pending.

import type { Breed } from '../core/types';

export const CLAY = {
  grass: 0x7c9c52,
  grassTop: 0x8fb060,
  dirt: 0x9a6f45,
  woodShavings: 0xd6b98a,
  balconyMat: 0x8a7f74,
  outline: 0x3a2c22,
  cream: 0xf3e6cf,
  shadow: 0x2a2018,
  accent: 0xc8763f,
} as const;

/** Body / comb colours for each breed's procedural placeholder. */
export const BREED_CLAY: Record<Breed, { body: number; comb: number }> = {
  silkie: { body: 0xf0ead6, comb: 0x6b4a7a },
  leghorn: { body: 0xfdfaf2, comb: 0xd0402f },
  rhode_island_red: { body: 0x9c3f22, comb: 0xd0402f },
  australorp: { body: 0x2b2b2b, comb: 0xd0402f },
  isa_brown: { body: 0x8a4b2a, comb: 0xd0402f },
  brahma: { body: 0xd9c2a3, comb: 0xd0402f },
  plymouth_rock: { body: 0x4a4a4a, comb: 0xd0402f },
  buff_orpington: { body: 0xd9a05b, comb: 0xd0402f },
};

export const TERRAIN_CLAY = {
  grass: CLAY.grass,
  dirt: CLAY.dirt,
  wood_shavings: CLAY.woodShavings,
  balcony_mat: CLAY.balconyMat,
} as const;

/** Darkens a colour by `amount` in [0,1] — used for tile side faces. */
export function shade(color: number, amount: number): number {
  const r = Math.round(((color >> 16) & 0xff) * (1 - amount));
  const g = Math.round(((color >> 8) & 0xff) * (1 - amount));
  const b = Math.round((color & 0xff) * (1 - amount));
  return (r << 16) | (g << 8) | b;
}
